
































































































































































































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  alertStore,
  appStore,
  modalErrorStore,
  modalBibliographySearchStore,
  modalBibliographySearchConditionStore,
  modalBibliographySearchHistoryStore,
  systemParameterStore,
  modalBibliographyDetailStore,
  dataStore
} from '@/store'
import { BibliographyFreeWordSearch } from '@/components/organisms/BibliographyFreeWordSearch'
import { BibliographyBasicSearchCollection } from '@/components/organisms/BibliographyBasicSearchCollection'
import { BibliographyAloneSearch } from '@/components/organisms/BibliographyAloneSearch'
import { BibliographyAuthoritySearch } from '@/components/organisms/BibliographyAuthoritySearch'
import { BibliographyContentSearch } from '@/components/organisms/BibliographyContentSearch'
import {
  BibliographySearchOption,
  InputSearchOptionItem
} from '@/components/organisms/BibliographySearchOption'
import {
  defaultSearchCondition,
  SearchCondition
} from '@/pages/bibliographies/index.vue'
import BibliographyBasicSearchBibliography, {
  defaultInputBasicSearchBibliographyItem
} from '@/components/organisms/BibliographyBasicSearchBibliography/BibliographyBasicSearchBibliography.vue'
import {
  Alert,
  AlertMessage,
  ErrorMessage,
  SystemParameter,
  BibliographySearchHistory,
  BibliographySearchResultItem
} from '@/api'
import {
  SearchTarget,
  DisplayMethod,
  SearchType,
  BibliographyClass,
  AuthoritySearchType,
  BibliographySearchType,
  AloneSearchType,
  AppKeydown
} from '@/types'
import {
  PAGE_LOADING_END,
  PAGE_LOADING_START,
  APP_KEYDOWN
} from '@/config/event'
import { cloneDeep } from 'lodash'
import { defaultInputFreeWords } from '@/components/organisms/BibliographyFreeWordSearch/BibliographyFreeWordSearch.vue'
import {
  defaultInputBasicSearchCollectionItem,
  InputBasicSearchCollectionItem
} from '@/components/organisms/BibliographyBasicSearchCollection/BibliographyBasicSearchCollection.vue'
import { defaultInputSearchOptionItem } from '@/components/organisms/BibliographySearchOption/BibliographySearchOption.vue'
import {
  defaultInputAloneSearchItem,
  InputAloneSearchItem
} from '@/components/organisms/BibliographyAloneSearch/BibliographyAloneSearch.vue'
import { loadingSearchHistory } from '@/pages/bibliographies/index.type'
import { defaultInputAuthoritySearchItem } from '@/components/organisms/BibliographyAuthoritySearch/BibliographyAuthoritySearch.vue'
import { defaultInputContentSearchItem } from '@/components/organisms/BibliographyContentSearch/BibliographyContentSearch.vue'
import { SEARCH_CANCEL_DISPLAY_TIME } from '@/config'
import CODE_KEY from '@/config/code_key'
import { toHalfWidth } from '@/utils'
import { FirstTransitionToBibliographyDetail } from '@/store/BibliographyDetailStore'
import { InputBasicSearchBibliographyItem } from '@/components/organisms/BibliographyBasicSearchBibliography'
import {
  BibliographyFreeWordsSearchAndKey,
  defaultInputBibliographyFreeWordsSearchAndKeyItem,
  InputBibliographyFreeWordsSearchAndKeyItem
} from '@/components/organisms/BibliographyFreeWordsSearchAndKey'

@Component({
  components: {
    BibliographyFreeWordsSearchAndKey,
    BibliographyBasicSearchBibliography,
    BibliographySearchOption,
    BibliographyFreeWordSearch,
    BibliographyAloneSearch,
    BibliographyBasicSearchCollection,
    BibliographyAuthoritySearch,
    BibliographyContentSearch,
    ModalFooter
  }
})
export default class ModalBibliographySearchCondition extends ComponentVue {
  @Ref()
  bibliographyBasicSearchBibliography!: BibliographyBasicSearchBibliography

  @Ref()
  bibliographyAloneSearch!: BibliographyAloneSearch

  @Ref()
  bibliographyAuthoritySearch!: BibliographyAuthoritySearch

  @Ref()
  bibliographyContentSearch!: BibliographyContentSearch

  @Ref()
  bibliographyFreeWordSearch!: BibliographyFreeWordSearch

  searchCondition: SearchCondition = defaultSearchCondition()

  controller?: AbortController

  searching: boolean = false

  searchCancelSnackbar: boolean = false

  get isFreeSearch(): boolean {
    return this.existsFreeWords && !this.isTooliSearchTarget
  }

  get defaultDisplayMethod(): DisplayMethod {
    const option: string = this.presetValueSettingOnSearch2.option4

    const displayMethod = Object.values(DisplayMethod).find(item => {
      return option === item
    })

    return displayMethod ?? DisplayMethod.Simple
  }

  get isTooliSearch(): boolean {
    return modalBibliographySearchConditionStore.isTooliSearch
  }

  get isSearchTargetDisabled(): boolean {
    return modalBibliographySearchConditionStore.isSearchTargetDisabled
  }

  // TODO ダイアログに限り、systemParameterで初期値を参照しないようにする
  // 様子を見て削除する予定
  // get defaultSearchTarget(): SearchTarget {
  //   const option: string = this.presetValueSettingOnSearch1.option2
  //
  //   const searchTarget = Object.values(SearchTarget).find(item => {
  //     return option === item
  //   })
  //
  //   return searchTarget ?? SearchTarget.Db
  // }

  get defaultSearchMethodSynonym(): boolean {
    return this.presetValueSettingOnSearch2.option3 === '1'
  }

  get defaultSearchMethodAllograph(): boolean {
    return this.presetValueSettingOnSearch2.option2 === '1'
  }

  get defaultAndSearchType(): SearchType[] {
    const option: string = this.presetValueSettingOnSearch1.option1

    const searchType = Object.values(SearchType).find(item => {
      return option === item
    })

    if (searchType) {
      return [searchType]
    }

    return []
  }

  get defaultAndBibliographyClass(): BibliographyClass[] {
    const bibliographyClass = Object.values(BibliographyClass).find(
      value => value === this.presetValueSettingOnSearch1.option3
    )
    return bibliographyClass ? [bibliographyClass] : []
  }

  get existsFreeWords(): boolean {
    return !!this.searchCondition.free.freeWords.input
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get isOpen(): boolean {
    return modalBibliographySearchConditionStore.isOpen
  }

  get isTooliSearchTarget(): boolean {
    return (
      this.searchCondition.searchOption.searchTarget.input ===
      SearchTarget.Tooli
    )
  }

  get search(): any {
    if (this.isFreeSearch) {
      return this.freeSearch
    }

    const regexp = new RegExp(
      `^[0-9]{${
        systemParameterStore.collectionNoMaxDigits
      }}$|^D[0-9]{${systemParameterStore.collectionNoMaxDigits - 1}}$`
    )

    const search: any = {
      basic:
        !this.isTooliSearchTarget &&
        toHalfWidth(this.searchCondition.basic.bibliography.title1.input).match(
          regexp
        )
          ? () => this.aloneSearch(true)
          : this.basicSearch,
      alone: () => this.aloneSearch(false),
      authority: this.authoritySearch,
      content: this.contentSearch
    }

    return search[this.searchCondition.searchType]
  }

  get styleOfTabs(): object {
    if (this.fontSizeType === 'normal') return {}
    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get presetValueSettingOnSearch1(): SystemParameter {
    return systemParameterStore.presetValueSettingOnSearch1
  }

  get presetValueSettingOnSearch2(): SystemParameter {
    return systemParameterStore.presetValueSettingOnSearch2
  }

  get resetInputSearchOption(): InputSearchOptionItem {
    const item: InputSearchOptionItem = defaultInputSearchOptionItem()
    item.displayMethod.input = this.defaultDisplayMethod
    item.searchTarget.input = this.isTooliSearch
      ? SearchTarget.Tooli
      : SearchTarget.Db
    item.searchMethodSynonym.input = this.defaultSearchMethodSynonym
    item.searchMethodAllograph.input = this.defaultSearchMethodAllograph
    item.andSearchType = this.defaultAndSearchType
    item.andBibliographyClass = this.defaultAndBibliographyClass
    return item
  }

  get isHitOneSearchResults(): boolean {
    return modalBibliographySearchStore.total === 1
  }

  get searchResults(): BibliographySearchResultItem[] {
    return modalBibliographySearchStore.items
  }

  @Watch('searchCondition.basic.bibliography.title1.input')
  onInputTitle1(newVal: string) {
    const regexp = new RegExp(
      `^[0-9]{${
        systemParameterStore.collectionNoMaxDigits
      }}$|^D[0-9]{${systemParameterStore.collectionNoMaxDigits - 1}}$`
    )

    if (!this.isTooliSearchTarget && toHalfWidth(newVal).match(regexp)) {
      this.aloneSearch(true)
    }
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    systemParameterStore
      .fetchAllAndMergeByCodeKeys([
        CODE_KEY.PRESET_VALUE_SETTING_ON_SEARCH1.KEY,
        CODE_KEY.PRESET_VALUE_SETTING_ON_SEARCH2.KEY,
        CODE_KEY.NUMBER_MANAGEMENT.KEY // 資料番号入力欄で使用
      ])
      .then(() => {
        // 検索結果ダイアログが本ダイアログへ戻った際は、検索条件をリセットしない
        if (modalBibliographySearchConditionStore.isBack) return

        if (newVal) {
          this.searchCondition = defaultSearchCondition()
          this.$nextTick(() => {
            this.searchCondition = defaultSearchCondition()
            this.resetSearchConditionBasic()
            this.resetSearchConditionAlone()
            this.resetSearchConditionFreeWords()
            this.searchCondition.searchOption = this.resetInputSearchOption

            // 初期表示だけ制御したいのでこのタイミングで設定する
            this.searchCondition.alone.searchType =
              dataStore.bibliographySearchAloneInitialSelectValue

            // tooli指定の場合ラジオボタンの選択表示が無くなるので処理を追加
            if (this.isTooliSearchTarget) {
              this.searchCondition.alone.searchType =
                AloneSearchType.NewPublicationInformationVolume
            }
          })
        }
      })

    if (newVal) {
      this.$eventBus.on(APP_KEYDOWN, this.appKeydown)
      this.$nextTick(this.focus)
    } else {
      this.$eventBus.off(APP_KEYDOWN)
    }
  }

  appKeydown(event: AppKeydown): void {
    if (!event.ctrlKey) {
      return
    }

    if (event.key === '1') {
      this.searchCondition.searchType = BibliographySearchType.Basic
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.bibliographyBasicSearchBibliography.focus()
        })
      })
    } else if (event.key === '2') {
      this.searchCondition.searchType = BibliographySearchType.Basic
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.bibliographyBasicSearchBibliography.focusAuthor()
        })
      })
    } else if (event.key === '3') {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.bibliographyFreeWordSearch.focus()
        })
      })
    } else if (event.key === '4') {
      this.searchCondition.searchType = BibliographySearchType.Alone
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.searchCondition.alone.searchType = AloneSearchType.Isbn
          this.$nextTick(() => {
            this.bibliographyAloneSearch.focusIsbn()
          })
        })
      })
    } else if (event.key === '5') {
      this.searchCondition.searchType = BibliographySearchType.Alone
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.searchCondition.alone.searchType = AloneSearchType.Marc
          this.$nextTick(() => {
            this.bibliographyAloneSearch.focusMarcNo()
          })
        })
      })
    }
  }

  saveSearchCondition() {
    modalBibliographySearchStore.setSearchCondition(
      cloneDeep(this.searchCondition)
    )
  }

  clear(): void {
    if (this.searchCondition.free.freeWords.input !== '') {
      this.resetSearchConditionFreeWords()
      this.searchCondition.searchOption = defaultInputSearchOptionItem()
    }

    switch (this.searchCondition.searchType) {
      case 'basic':
        this.resetSearchConditionBasic()
        this.searchCondition.searchOption = defaultInputSearchOptionItem()
        break
      case 'alone':
        this.searchCondition.alone = defaultInputAloneSearchItem()
        this.resetSearchConditionAlone()
        this.searchCondition.searchOption.displayMethod = defaultInputSearchOptionItem().displayMethod
        this.searchCondition.searchOption.searchTarget = defaultInputSearchOptionItem().searchTarget
        this.searchCondition.searchOption.numberOfLimit = defaultInputSearchOptionItem().numberOfLimit
        break
      case 'authority':
        this.searchCondition.authority = defaultInputAuthoritySearchItem()
        this.searchCondition.searchOption.searchTarget = defaultInputSearchOptionItem().searchTarget
        this.searchCondition.searchOption.numberOfLimit = defaultInputSearchOptionItem().numberOfLimit
        break
      case 'content':
        this.searchCondition.content = defaultInputContentSearchItem()
        this.searchCondition.searchOption.displayMethod = defaultInputSearchOptionItem().displayMethod
        this.searchCondition.searchOption.searchTarget = defaultInputSearchOptionItem().searchTarget
        this.searchCondition.searchOption.numberOfLimit = defaultInputSearchOptionItem().numberOfLimit
        this.searchCondition.searchOption.searchMethodAnd = defaultInputSearchOptionItem().searchMethodAnd
        this.searchCondition.searchOption.searchMethodSynonym = defaultInputSearchOptionItem().searchMethodSynonym
        this.searchCondition.searchOption.searchMethodAllograph = defaultInputSearchOptionItem().searchMethodAllograph
        this.searchCondition.searchOption.andSearchType = defaultInputSearchOptionItem().andSearchType
        this.searchCondition.searchOption.andCollectionTarget = defaultInputSearchOptionItem().andCollectionTarget
    }

    this.focus()
  }

  startSearchCanceler() {
    this.controller = new AbortController()
    setTimeout(() => {
      if (this.searching) {
        this.searchCancelSnackbar = true
      }
    }, SEARCH_CANCEL_DISPLAY_TIME)
  }

  stopSearchCanceler() {
    this.controller = undefined
    this.searchCancelSnackbar = false
  }

  onClickSearchCancel() {
    this.searchCancelSnackbar = false
    if (this.controller) {
      this.controller.abort()
    }
  }

  onChangeTab(searchType: BibliographySearchType): void {
    this.searchCondition.searchType = searchType
    this.focus()
  }

  resetSearchConditionBasic(): void {
    const bibliographyItem: InputBasicSearchBibliographyItem = defaultInputBasicSearchBibliographyItem()
    const collectionItem: InputBasicSearchCollectionItem = defaultInputBasicSearchCollectionItem()

    bibliographyItem.titleInformation =
      systemParameterStore.defaultCollectionSearchTitleInformationValue
    collectionItem.holdingBranchCodes.input = systemParameterStore.presetValueSettingOnSearch1.option4.replace(
      /(\d)(?=(\d\d)+(?!\d))/g,
      '$1,'
    )
    collectionItem.collectionStatus.collectionStatusRemove =
      systemParameterStore.defaultCollectionStatusRemove

    this.searchCondition.basic.bibliography = bibliographyItem
    this.searchCondition.basic.collection = collectionItem
  }

  resetSearchConditionAlone(): void {
    const item: InputAloneSearchItem = defaultInputAloneSearchItem()

    item.marcType.input =
      systemParameterStore.presetValueSettingOnSearch1.option5

    this.searchCondition.alone = item
  }

  resetSearchConditionFreeWords(): void {
    const andKeyItem: InputBibliographyFreeWordsSearchAndKeyItem = defaultInputBibliographyFreeWordsSearchAndKeyItem()

    andKeyItem.holdingBranchCodes.input = systemParameterStore.presetValueSettingOnSearch1.option4.replace(
      /(\d)(?=(\d\d)+(?!\d))/g,
      '$1,'
    )
    andKeyItem.collectionStatus.collectionStatusRemove =
      systemParameterStore.defaultCollectionStatusRemove

    this.searchCondition.free.freeWords = defaultInputFreeWords()
    this.searchCondition.free.andKey = andKeyItem
  }

  focus(): void {
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        switch (this.searchCondition.searchType) {
          case 'basic':
            this.bibliographyBasicSearchBibliography.focus()
            break
          case 'alone':
            this.bibliographyAloneSearch.focus()
            break
          case 'authority':
            this.bibliographyAuthoritySearch.focus()
            break
          case 'content':
            this.bibliographyContentSearch.focus()
            break
        }
      })
    })
  }

  async basicSearch() {
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()

    this.searching = true
    this.startSearchCanceler()

    try {
      modalBibliographySearchStore.reset()
      modalBibliographyDetailStore.reset()
      if (
        modalBibliographySearchStore.inputSearchOption.searchTarget.input ===
        SearchTarget.Tooli
      ) {
        await modalBibliographySearchStore.basicSearchTooli(
          this.controller?.signal
        )
      } else {
        await modalBibliographySearchStore.basicSearch(this.controller?.signal)
      }

      if (this.isHitOneSearchResults) {
        modalBibliographyDetailStore.setFirstTransitionSource(
          FirstTransitionToBibliographyDetail.Search
        )
      }

      modalBibliographySearchConditionStore.searchComplete()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfBasicSearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async aloneSearch(isInputBasicSearch: boolean) {
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()

    this.searching = true
    this.startSearchCanceler()

    try {
      modalBibliographySearchStore.reset()
      modalBibliographyDetailStore.reset()
      if (
        modalBibliographySearchStore.inputSearchOption.searchTarget.input ===
        SearchTarget.Tooli
      ) {
        await modalBibliographySearchStore.aloneSearchTooli(
          this.controller?.signal
        )
      } else {
        await modalBibliographySearchStore.aloneSearch(
          isInputBasicSearch,
          this.controller?.signal
        )
      }

      if (this.isHitOneSearchResults) {
        modalBibliographyDetailStore.setFirstTransitionSource(
          FirstTransitionToBibliographyDetail.Search
        )
      }

      this.close()
      modalBibliographySearchConditionStore.searchComplete()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfAloneSearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async authoritySearch() {
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()
    modalBibliographySearchStore.setAuthoritySearchType(
      this.searchCondition.authority.searchType
    )

    this.searching = true
    this.startSearchCanceler()

    try {
      modalBibliographySearchStore.reset()
      modalBibliographyDetailStore.reset()
      await modalBibliographySearchStore.authoritySearch(
        this.controller?.signal
      )
      if (modalBibliographySearchStore.authorityItems.length === 1) {
        if (
          this.searchCondition.authority.searchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          await this.authorityIdContentSearch()
        } else {
          await this.authorityIdSearch()
        }
      }
      this.close()
      modalBibliographySearchConditionStore.searchAuthorityComplete()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfAuthoritySearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // 典拠検索結果のbibliographyCountが合計1のみだった場合
  async authorityIdSearch() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const nos: string[] = [
        modalBibliographySearchStore.authorityItems[0].authorityNo
      ]
      switch (modalBibliographySearchStore.authoritySearchType) {
        case AuthoritySearchType.Author:
          modalBibliographySearchStore.setAuthorIds(nos)
          break
        case AuthoritySearchType.ContentAuthor:
          modalBibliographySearchStore.setContentAuthorIds(nos)
          break
        case AuthoritySearchType.Subject:
          modalBibliographySearchStore.setSubjectIds(nos)
          break
        case AuthoritySearchType.CompleteWorks:
          modalBibliographySearchStore.setCompleteWorksIds(nos)
          break
        case AuthoritySearchType.Series:
          modalBibliographySearchStore.setSeriesIds(nos)
          break
        case AuthoritySearchType.Publisher:
          modalBibliographySearchStore.setPublisherIds(nos)
          break
      }

      await modalBibliographySearchStore.authorityIdSearch()

      if (this.isHitOneSearchResults) {
        modalBibliographyDetailStore.setFirstTransitionSource(
          FirstTransitionToBibliographyDetail.Search
        )
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async authorityIdContentSearch() {
    this.$eventBus.emit(PAGE_LOADING_START)

    const nos = [modalBibliographySearchStore.authorityItems[0].authorityNo]

    try {
      modalBibliographySearchStore.resetPage()
      modalBibliographySearchStore.setContentAuthorIds(nos)

      await modalBibliographySearchStore.authorityIdContentSearch()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async contentSearch() {
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()

    this.searching = true
    this.startSearchCanceler()

    try {
      modalBibliographySearchStore.reset()
      modalBibliographyDetailStore.reset()
      if (
        modalBibliographySearchStore.inputSearchOption.searchTarget.input ===
        SearchTarget.Tooli
      ) {
        await modalBibliographySearchStore.contentSearchTooli(
          this.controller?.signal
        )
      } else {
        await modalBibliographySearchStore.contentSearch(
          this.controller?.signal
        )
      }

      if (this.isHitOneSearchResults) {
        modalBibliographyDetailStore.setFirstTransitionSource(
          FirstTransitionToBibliographyDetail.Search
        )
      }

      this.close()
      modalBibliographySearchConditionStore.searchContentComplete()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfContentSearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async freeSearch() {
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()

    this.searching = true
    this.startSearchCanceler()

    try {
      modalBibliographySearchStore.reset()
      modalBibliographyDetailStore.reset()
      await modalBibliographySearchStore.freeSearch(this.controller?.signal)

      if (this.isHitOneSearchResults) {
        modalBibliographyDetailStore.setFirstTransitionSource(
          FirstTransitionToBibliographyDetail.Search
        )
      }

      this.close()
      modalBibliographySearchConditionStore.searchComplete()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfFreeSearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  close(): void {
    modalBibliographySearchConditionStore.close()
  }

  onClickPrint(): void {
    const element = document.getElementById(
      'modal-bibliography-search-condition'
    )
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  convertCamelCaseFromSnakeCase(value: string): string {
    return value.replace(/_./g, str => str.charAt(1).toUpperCase())
  }

  onClickSearchHistory(): void {
    modalBibliographySearchHistoryStore.open({
      onClickExecution: (item: BibliographySearchHistory) => {
        this.searchCondition = loadingSearchHistory(item)
        this.search()
      },
      onClickLoading: (item: BibliographySearchHistory) => {
        this.searchCondition = loadingSearchHistory(item)
      }
    })
  }

  setErrorMessageOfContentSearch(alerts: Alert[]) {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      let setTargetItem: any = this.searchCondition.content
      if (
        [
          'display_method',
          'search_target',
          'number_of_limit',
          'search_method_and',
          'search_method_synonym',
          'search_method_allograph',
          'and_search_type',
          'and_collection_target',
          'and_bibliography_class'
        ].includes(alert.attribute)
      ) {
        setTargetItem = this.searchCondition.searchOption
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        alert.attribute
      ).replace(/(Not$)|(Id$)/g, '')

      if (setTargetItem[convertedPropertyName]) {
        setTargetItem[convertedPropertyName].errorMessage = alert.message
      }
    })
  }

  setErrorMessageOfAuthoritySearch(alerts: Alert[]) {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      let setTargetItem: any = this.searchCondition.authority
      if (['search_target', 'number_of_limit'].includes(alert.attribute)) {
        setTargetItem = this.searchCondition.searchOption
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        alert.attribute
      ).replace(/Id$/g, '')

      if (setTargetItem[convertedPropertyName]) {
        setTargetItem[convertedPropertyName].errorMessage = alert.message
      }
    })
  }

  setErrorMessageOfAloneSearch(alerts: Alert[]) {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      let setTargetItem: any = this.searchCondition.alone
      if (
        ['display_method', 'search_target', 'number_of_limit'].includes(
          alert.attribute
        )
      ) {
        setTargetItem = this.searchCondition.searchOption
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        alert.attribute
      )

      if (setTargetItem[convertedPropertyName]) {
        setTargetItem[convertedPropertyName].errorMessage = alert.message
      }
    })
  }

  setErrorMessageOfBasicSearch(alerts: Alert[]) {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      // eslint-disable-next-line prefer-const
      let [target1, target2] = alert.attribute.split('.')
      let setTargetObject: any = this.searchCondition.searchOption
      switch (target1) {
        case 'bibliography':
          setTargetObject = this.searchCondition.basic.bibliography
          target1 = target2
          break
        case 'collection':
          setTargetObject = this.searchCondition.basic.collection
          target1 = target2
          break
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        target1
      ).replace(/(Not$)|(Id$)|(Flag$)/g, '')

      if (setTargetObject[convertedPropertyName]) {
        setTargetObject[convertedPropertyName].errorMessage = alert.message
      }
    })
  }

  setErrorMessageOfFreeSearch(alerts: Alert[]): void {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      // eslint-disable-next-line prefer-const
      let [target1, target2] = alert.attribute.split('.')
      let setTargetObject: any = this.searchCondition.searchOption
      switch (target1) {
        case 'free_words':
          this.searchCondition.free.freeWords.errorMessage = alert.message
          return false
        case 'bibliography':
          setTargetObject = this.searchCondition.free.andKey
          target1 = target2
          break
        case 'collection':
          setTargetObject = this.searchCondition.free.andKey
          target1 = target2
          break
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        target1
      ).replace(/(Not$)|(Id$)|(Flag$)/g, '')

      if (setTargetObject[convertedPropertyName]) {
        setTargetObject[convertedPropertyName].errorMessage = alert.message
      }
    })
  }
}
